import ManagementTable from "src/components/pages/Management/ManagementTable/ManagementTable";
import Breadcrumbs from "src/components/shared/Breadcrumbs/Breadcrumbs";
import { useGetApi } from "src/hooks";
import { PageContainer } from "src/styled";

const ApiKeys = () => {
  const { isLoading } = useGetApi({
    request: "get-management",
    body: { _sect: "_api" },
  });

  return (
    <PageContainer>
      <Breadcrumbs border={false} />
      <ManagementTable section="_api" data={[]} loading={isLoading} />
    </PageContainer>
  );
};

export default ApiKeys;
